// extracted by mini-css-extract-plugin
export default {"separator":"NavBar_separator__Boh1f","container":"NavBar_container__YuZWp","l":"NavBar_l__+GNcx"};